import {
  WORKSPACE_USER_ID_PARAM,
  applyWorkspaceUserIdToSearchParams,
  readWorkspaceUserIdFromSearch,
} from "./workspaceOwner";

export const WORKSPACE_GROUP_ID_PARAM = "group_id";
export const WORKSPACE_WIDGET_ID_PARAM = "widget_id";

/** Parse workspace deep-link query params from location.search. */
export function readWorkspaceDeepLinkFromSearch(search) {
  const params = new URLSearchParams(search || "");
  const groupRaw = params.get(WORKSPACE_GROUP_ID_PARAM);
  const widgetRaw = params.get(WORKSPACE_WIDGET_ID_PARAM);
  const groupId =
    groupRaw != null &&
    groupRaw !== "" &&
    Number.isFinite(Number(groupRaw))
      ? Number(groupRaw)
      : null;
  const widgetId =
    widgetRaw != null &&
    widgetRaw !== "" &&
    Number.isFinite(Number(widgetRaw))
      ? Number(widgetRaw)
      : null;
  return {
    groupId,
    widgetId,
    workspaceUserId: readWorkspaceUserIdFromSearch(search),
    since: params.get("since") || null,
    until: params.get("until") || null,
  };
}

/** Relative path: /console/my-workspace?group_id=…&widget_id=… */
export function buildWorkspaceDeepLink({
  groupId,
  widgetId,
  workspaceUserId,
  currentUserId,
  since,
  until,
} = {}) {
  const params = new URLSearchParams();
  if (groupId != null && Number.isFinite(Number(groupId))) {
    params.set(WORKSPACE_GROUP_ID_PARAM, String(groupId));
  }
  if (widgetId != null && Number.isFinite(Number(widgetId))) {
    params.set(WORKSPACE_WIDGET_ID_PARAM, String(widgetId));
  }
  applyWorkspaceUserIdToSearchParams(params, workspaceUserId, currentUserId);
  if (since) params.set("since", String(since));
  if (until) params.set("until", String(until));
  const qs = params.toString();
  return `/console/my-workspace${qs ? `?${qs}` : ""}`;
}

export function buildWorkspaceDeepLinkAbsolute(
  baseUrl,
  options = {},
) {
  const path = buildWorkspaceDeepLink(options);
  const base = String(baseUrl || "").replace(/\/$/, "");
  return `${base}${path}`;
}

export function buildAiReportDeepLink({
  reportId,
  widgetId,
  workspaceUserId,
  currentUserId,
  since,
  until,
} = {}) {
  const params = new URLSearchParams();
  if (widgetId != null && Number.isFinite(Number(widgetId))) {
    params.set(WORKSPACE_WIDGET_ID_PARAM, String(widgetId));
  }
  applyWorkspaceUserIdToSearchParams(params, workspaceUserId, currentUserId);
  if (since) params.set("since", String(since));
  if (until) params.set("until", String(until));
  const qs = params.toString();
  return `/console/ai-services/auto-reports/${Number(reportId)}${qs ? `?${qs}` : ""}`;
}

/** API path for AI report detail + sub-resources (optional workspace_user_id query). */
export function buildAiReportApiRequestPath(reportId, suffix = "", workspaceUserId) {
  let path = `welcome/ai-services/reports/${Number(reportId)}${suffix}`;
  const trimmed = workspaceUserId?.trim();
  if (trimmed) {
    path += `?${WORKSPACE_USER_ID_PARAM}=${encodeURIComponent(trimmed)}`;
  }
  return path;
}

export function buildReportsDownloadsDeepLinkAbsolute(baseUrl) {
  const base = String(baseUrl || "").replace(/\/$/, "");
  return `${base}/console/report?page=report`;
}
